import dataService from "../../api";
import { status } from "@/utils/common";

import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        patientsPayments: [],
        patientsPayment: {
            id: null,
            fullName: null,
            bloodType: null,
            birthDate: null,
            gender: null,
            Disease :[],
            SkinIssues :[],
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.patientsPayments.findIndex(i => i.id === id)
    },
    mutations: {
        SET_PatientsPayments: (state, data) => state.patientsPayments = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_patientsPayment: (state, viewData) => state.patientsPayment = viewData,
        UPDATE: (state, { index, updateData }) => state.patientsPayments.splice(index, 1, updateData),
        cancel: (state, index) => state.patientsPayments[index].status = status.cancel,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.treasury.getAll(paramsString);
                    stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_PatientsPayments', response.data.patientsPayments);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_patientsPayment', {});
                const response = await dataService.treasury.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_patientsPayment', response.data.patientsPayment);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
    
         async getForComplete(_, id) {
            startLoading()
            try {
                const response = await dataService.treasury.getForComplete(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                
            }
        },  
         async getForReceipt(_, id) {
            startLoading()
            try {
                const response = await dataService.treasury.getForReceipt(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                
                return Promise.resolve(response.data);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
     
       

         async complete({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.treasury.complete(id,payload);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.patientsPayment });
                return Promise.resolve(response.data);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
 
         async cancel({ commit, getters },  id) {
            startLoading()
            try {
                const response = await dataService.treasury.cancel(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('cancel',  index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
 

    },
};
